/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sleek_Neat_Otter_PeelInputs */

const es_sleek_neat_otter_peel = /** @type {(inputs: Sleek_Neat_Otter_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoritos`)
};

const gl_sleek_neat_otter_peel = /** @type {(inputs: Sleek_Neat_Otter_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoritos`)
};

const en_sleek_neat_otter_peel = /** @type {(inputs: Sleek_Neat_Otter_PeelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorites`)
};

/**
* | output |
* | --- |
* | "Favorites" |
*
* @param {Sleek_Neat_Otter_PeelInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const sleek_neat_otter_peel = /** @type {((inputs?: Sleek_Neat_Otter_PeelInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sleek_Neat_Otter_PeelInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_sleek_neat_otter_peel(inputs)
	if (locale === "en") return en_sleek_neat_otter_peel(inputs)
	return es_sleek_neat_otter_peel(inputs)
});